import { render, staticRenderFns } from "./StatusOfGoal.vue?vue&type=template&id=723d417e&scoped=true"
import script from "./StatusOfGoal.vue?vue&type=script&lang=js"
export * from "./StatusOfGoal.vue?vue&type=script&lang=js"
import style0 from "./StatusOfGoal.vue?vue&type=style&index=0&id=723d417e&prod&scoped=true&scss=lang&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723d417e",
  null
  
)

export default component.exports